import Header from "@/components/app/Header";
import GoogleButton from "@/components/app/GoogleButton";
import { Link } from "react-router-dom";
import { ShieldCheck, Zap, Users } from "lucide-react";

export default function Login() {
  return <AuthScreen title="Welcome back" tagline="Sign in to ClosetFlip" cta="Sign in with Google" />;
}

export function AuthScreen({ title, tagline, cta, altLinkText = "Just here to browse?", altLinkTo = "/pricing", altLinkLabel = "See pricing →" }) {
  return (
    <div className="min-h-screen mesh-bg">
      <Header />
      <div className="max-w-md mx-auto px-6 py-16">
        <div className="rounded-2xl border border-white/8 bg-white/[0.02] p-8">
          <p className="font-mono text-xs uppercase tracking-[0.22em] text-emerald-400 mb-2">{title}</p>
          <h1 className="font-display font-semibold text-3xl tracking-tight mb-2">{tagline}</h1>
          <p className="text-zinc-400 mb-8 text-sm">1 free scan on signup. No card. Continue with your Google account.</p>

          <GoogleButton label={cta} testid="google-auth" />

          <ul className="mt-8 space-y-3 text-sm text-zinc-400">
            <li className="flex items-start gap-3">
              <ShieldCheck className="w-4 h-4 mt-0.5 text-emerald-400 shrink-0" />
              <span>Verified accounts only — no fake emails, no bots.</span>
            </li>
            <li className="flex items-start gap-3">
              <Zap className="w-4 h-4 mt-0.5 text-emerald-400 shrink-0" />
              <span>One-click sign-in. Never a password to remember.</span>
            </li>
            <li className="flex items-start gap-3">
              <Users className="w-4 h-4 mt-0.5 text-emerald-400 shrink-0" />
              <span>We only ever read your name, email, and avatar.</span>
            </li>
          </ul>

          <p className="mt-8 text-xs text-zinc-500 text-center">
            {altLinkText}{" "}
            <Link to={altLinkTo} className="text-emerald-400 hover:underline">
              {altLinkLabel}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
